// Compliance audit trail for data/report exports.
// Fire-and-forget: records who/when/what/tenant without ever blocking the download.
export const logReportExport = (api, payload) => {
  if (!api) return;
  try {
    api.post('/audit/export', payload).catch(() => {});
  } catch (_e) {
    /* never block a download on an audit failure */
  }
};
